import React from 'react'
import classNames from 'classnames/bind'

import { siteNames } from '../../../common/constants/siteList'

import styles from './marketSiteMenu.module.css'

const siteTitles = {
  audiojungle: 'Stock Music and Audio',
  themeforest: 'Website Templates',
  videohive: 'Motion Graphics',
  graphicriver: 'Graphics, Vectors and Print',
  '3docean': '3D Models and Materials',
  codecanyon: 'Code, Plugins and Mobile',
  photodune: 'Stock Photography'
}

const cx = classNames.bind(styles)

export default ({
  currentSite
}) => (
  <div className={styles.headerSitesWrapper}>
    <div className={styles.headerSites}>
      <div className={styles.gridWide}>
        <nav className={styles.headerSitesContainer}>
          {
            siteNames.map((site, index) => {
              const isCurrentSite = site === currentSite
              const shouldHaveOsr = !isCurrentSite ? '?osr=tn' : ''
              const siteLink = `https://${site}.net/${shouldHaveOsr}`
              const linkClassName = cx(
                styles.sitesLink,
                styles[`siteLink${site}`],
                {
                  active: isCurrentSite
                }
              )
              const siteTitle = siteTitles[site]
              return (
                <a
                  key={index}
                  href={siteLink}
                  className={linkClassName}
                  title={siteTitle}
                  data-test-selector='site-link'>
                  {site}
                </a>
              )
            })
          }
        </nav>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./client/components/siteHeader/marketSiteMenu.js